
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[projectSlug]",
      function () {
        return require("private-next-pages/project/[projectSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[projectSlug]"])
      });
    }
  